module.exports = __webpack_public_path__ + "media/images/games/k2gender/orange-575d734326f9a3a14e6cf712a34c4824.png";